/* eslint-disable no-nested-ternary */
import styled from 'styled-components';
import { media } from 'style-utils';

const Page = styled.main`
  padding-top: ${props => (props.header ? null : '16px')};
  padding-bottom: ${props =>
    props.footer ? 200 : props.withPbiEmbed ? 0 : 70}px;

  ${media.tablet`
    padding-bottom: ${props =>
      props.footer ? 200 : props.withPbiEmbed ? 0 : 60}px;
  `}

  ${media.mobile`
    padding-bottom: ${props =>
      props.footer ? 350 : props.withPbiEmbed ? 0 : 60}px;
  `}
`;

export default Page;



// WEBPACK FOOTER //
// ./src/components/layouts/Page.js